import { createSlice } from '@reduxjs/toolkit'
import createQueryString from 'src/utils/createQueryString'
import axios from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import { failed, success } from './snackSlice'
import saveData from '../../utils/saveFile'

export const discountSlice = createSlice({
  name: 'discount',
  initialState: {
    list: [],
    totalHits: 0,
    discountGroup: [],
  },
  reducers: {
    discountsFetched: (state, { payload }) => payload,
    discountGroupFetched: (state, { payload }) => {
      state.discountGroup = payload
    },
  },
})

export const {
  discountsFetched,
  discountGroupFetched,
} = discountSlice.actions

export default discountSlice.reducer

export const getDiscounts = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.get('discount', { params: createQueryString(data) })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(discountsFetched({
        list: res.data.data,
        totalHits: res.data.totalHits,
      }))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('خطا در دریافت لیست تخفیف‌ها'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const getDiscountById = (id) => (dispatch) => {
  dispatch(startLoading())
  axios.get(`discount/${id}`)
    .then(() => {
      dispatch(success('تخفیف انتخابی لحاظ شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('تخفیف انتخابی لحاظ نشد'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const getDiscountCode = (code) => (dispatch) => {
  dispatch(startLoading())
  axios.get(`discount/bycode/${code}`)
    .then(() => {
      dispatch(success('تخفیف انتخابی لحاظ شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('تخفیف انتخابی لحاظ نشد'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const addDiscount = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.post('discount', data)
    .then(() => {
      dispatch(success('تخفیف جدید اضافه گردید'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('خطا در ثبت تخفیف'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const addDiscountGroup = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.post('discount/group', data)
    .then(() => {
      dispatch(success('گروه جدید اضافه گردید'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const getDiscountGroup = () => (dispatch) => {
  dispatch(startLoading())
  axios.get('discount/group')
    .then((res) => {
      dispatch(discountGroupFetched(res?.data?.data))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const generateDiscount = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.post(`discount/generate/${data.count}`, data)
    .then(() => {
      dispatch(success('تخفیف‌های جدید اضافه گردید'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('‌خطا در ثبت تخفیف‌ها'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const editDiscount = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.put('discount', data)
    .then(() => {
      dispatch(success('تخفیف اصلاح گردید'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('خطا در ثبت تغییرات'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const deleteDiscount = (discountIdList) => (dispatch) => {
  dispatch(startLoading())
  axios.delete('discount/delete', { data: discountIdList })
    .then(() => {
      dispatch(success(discountIdList.length > 1 ? 'تخفیف‌ها حذف گردید' : 'تخفیف حذف گردید'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('خطا در حذف تخفیف مورد نظر'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const downloadDiscounts = (url) => (dispatch) => {
  dispatch(startLoading())
  axios.get(url)
    .then((res) => {
      saveData({
        data: res.data,
        fileName: url,
        type: 'text/plain;charset=utf-8',
      })
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('خطا در دریافت فایل تخفیف‌ها'))
      dispatch(stopLoading())
      console.error(e)
    })
}

export const selectorDiscountGroup = (state) => state.discount.discountGroup
